import React, { useEffect, useState } from 'react'
import {Header, TitlePage, ControlsContainer, ButtonBackWraper, CustomTextControl, Container, StyledLink} from './styles'
import ControlsBlock from '@/components/blocks/HeaderPageMobile/ControlsBlock'
import {
  SUMMARY_ALARMS_ANALYTICS_URL,
} from '@/constants/routes'
import GlobalPopup from '@/components/blocks/GlobalPopup'

import BackIcon from '@/components/icons/maps/BackIcon'
import UsersIcons from '@/components/icons/users'
import SearchSwiper from '@/components/blocks/SearchSwiper'
import SwiperSD from '@/components/blocks/SwiperSD'
import useUrlParseAndPush from '@/hooks/useUrlParseAndPush'
import debounce from 'lodash/debounce'

import {
  DEBOUNCE_DELAY_LARGE,
} from '@/constants/time'




const HeaderMobile = (
  {
    title,
    controls,
    buttonBack,
    onClose,
    content,
    opacyti,
    openPopup,
    data,
    onChange,
    checkBoxOption,
    value,
    searchActive,
    onChangeInput,
    resetSearch,
    swiperSD,
    infoCards,
  }) => {

    const [urlValues, setUrlValues] = useUrlParseAndPush()
    const [searchValue, setSearchValue] = useState('')

    useEffect(() => {
      if (urlValues.search) {
        setSearchValue(urlValues.search)
      } else {
        setSearchValue('')
      }
    }, [urlValues.search])
    
    const setUrlValuesSearch = debounce((value) => {
      setUrlValues({
        ...urlValues,
        search: value,
      })
    }, DEBOUNCE_DELAY_LARGE)

    const onChangeInputSD = (value) => {
      setSearchValue(value)
      setUrlValuesSearch(value)
    }

    const resetSearchSD = () => {
      setUrlValues({
        ...urlValues,
        search: '',
      })
      setSearchValue('')
    }
  return (
    <>
    {openPopup && 
      <GlobalPopup
      content={content}
      opacyti={opacyti}
    />
    }
    <Container withBorder>
      <Header>
          {buttonBack && 
            <StyledLink to ={SUMMARY_ALARMS_ANALYTICS_URL} onClick={resetSearch}>
              <BackIcon color={'#1061DF'}/>
            </StyledLink>
          }
          {!buttonBack && onClose && 
            <ButtonBackWraper>
              <BackIcon onClick={onClose} color={'#1061DF'}/>
            </ButtonBackWraper>
          }
          <TitlePage buttonBack={onClose}>{title}</TitlePage> 
          <ControlsContainer>
              <ControlsBlock
                controls={controls}
                spaced
              />
          </ControlsContainer>
        </Header>
        {searchActive &&
          <CustomTextControl
          dark
          placeholder="Найти..."
          name="search"
          value={value || searchValue}
          icon={UsersIcons.MagnifierIcon}
          onChange={onChangeInput || onChangeInputSD}
          resetButton
          resetField={resetSearch || resetSearchSD}
          />
        }
        {data && <SearchSwiper data={data} onChange={onChange} checkBoxOption={checkBoxOption}/>}
        {swiperSD && <SwiperSD infoCards={infoCards}/>}
    </Container>
  
    </>
  )
}

export default HeaderMobile